import { appRoutes } from "@/lib/routes";

/**
 * The routes the build emits a prerendered document for.
 *
 * Separate from `routes.tsx` because the app itself has to read this — the
 * auth gate needs to know which paths already have readable markup on screen
 * when the bundle boots — and `routes.tsx` imports `react-dom/server`, which
 * has no business in a client bundle.
 *
 * One place names each path, so the document the build writes and the
 * behaviour the app takes on the strength of it cannot drift apart.
 */
export const PRERENDERED_PATHS = {
  signup: appRoutes.signup(),
} as const;

const ALL_PRERENDERED: readonly string[] = Object.values(PRERENDERED_PATHS);

/** Whether the build wrote a document for this exact path. */
export function isPrerenderedPath(path: string): boolean {
  return ALL_PRERENDERED.includes(path);
}
